










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { default as DxDataSource } from 'devextreme/data/data_source';

import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import Chart, { ChartSeries, ChartConfig } from '@/core/components/chart';

@Component({
    components: {
        Chart,
    },
})
export default class ResourceUsageChart extends Vue {
    @Prop({ type: Array, required: true }) public chartData!: any[];

    public get dataSource() {
        return new DxDataSource({
            store: this.chartData,
            pageSize: Infinity,
        });
    }

    public refresh() {
        (this.$refs.chart as Chart).rerenderOnResize();
    }

    public get chartConfig(): Partial<ChartConfig> {
        return {
            height: '100%',
            zoomAndPan: {
                allowMouseWheel: true,
                argumentAxis: 'both',
            },
            argumentAxis: {
                argumentType: 'datetime',
                tickInterval: 'day',
                constantLines: [
                    {
                        value: ContextsState.current
                                ? ContextsState.current.currentTime
                                : '',
                        label: {
                            text: localize('IndicatorsChartsCurrentTime'),
                            verticalAlignment: 'top',
                            horizontalAlignment: 'right',
                            font: {
                                color: 'black',
                                opacity: 1,
                            },
                        },
                    },
                ],
                label: {
                    customizeText: (axisArgument: any): string => axisArgument.value.toLocaleDateString(),
                },
            },
        };
    }

    public get series(): ChartSeries {
        return {
            argumentField: 'date',
            valueField: 'count',
        };
    }
}
